import { style } from '@vanilla-extract/css'

export const wrapper = style({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 10,
  gridColumn: '1 / -1'
})

export const wrapperCenter = style({
  justifyContent: 'center'
})

export const wrapperRight = style({
  justifyContent: 'flex-end'
})

export const wrapperSpaceBetween = style({
  justifyContent: 'space-between'
})
